import { useState } from "react";
import { toast } from "react-toastify";
import { linkFacebookAdsAccount } from "../../../../services/ApiService";
import { getIntegrationErrorMessage } from "../../../../utils/oauthErrors";
import { useNavigate } from "react-router-dom";

export const FacebookAdsAccountTable = ({
    facebookAdAccounts,
    fetchAdsAccountStatus,
    setShowAdsAccountsModal,
    onLinked = () => {},
}) => {
    const [linking, setlinking] = useState(false);
    const navigate=useNavigate()
    const headers = [
        { label: "Sl.No", key: "sl.no" },
        { label: "Account Id", key: "id" },
        { label: "Account Name", key: "name" },
        { label: "Actions", key: "actions" },
    ];

    const handleConnect = async (ad_account_id, index) => {
        setlinking((prev) => ({ ...prev, [index]: true })); // Set loading for the specific button
        try {
            
            const data = await linkFacebookAdsAccount(ad_account_id);
          
            if (data?.success) {
                toast.success(data?.message || 'Facebook Ads account linked successfully');
                setShowAdsAccountsModal(false);
                fetchAdsAccountStatus?.();
                onLinked();
            } else {
                toast.error(getIntegrationErrorMessage(data, 'Error connecting Facebook Ads Account'));
            }
        } catch (error) {
            toast.error(getIntegrationErrorMessage(error, 'Error connecting Facebook Ads Account'));
        } finally {
            setlinking((prev) => ({ ...prev, [index]: false }));
            navigate('/client/settings/integrations', { replace: true });
        }
    };

    return (
        <div className="card-lg bg-light">
            <div className="table-responsive text-nowrap card-body py-0">
                <table className="table table-row-dashed table-row-gray-300 align-middle gs-0 gy-4 table-auto m-0">
                    <thead>
                        <tr className="fw-bold text-muted bg-light ">
                            {headers.map((header) => (
                                <th className={`min-w-100px ${header.label==='Actions'&&'text-end'}`} key={header.key}>
                                    {header.label}
                                </th>
                            ))}
                        </tr>
                    </thead>
                    <tbody>
                        {facebookAdAccounts?.length === 0 ? (
                            <tr>
                                <td colSpan={headers.length} className="text-center text-muted">
                                    No data available
                                </td>
                            </tr>
                        ) : (
                            facebookAdAccounts?.map((account, index) => (
                                <tr className="text-muted" key={index}>
                                    <td>{index + 1}</td>
                                    <td>{account?.id || "---"}</td>
                                    <td>{account?.name || "---"}</td>
                                     <td className="d-flex justify-content-end">
                                        <button
                                            className="btn btn-sm rounded-pill btn-primary d-flex align-items-center justify-content-center"
                                            style={{ width: "150px" }}
                                            onClick={() => handleConnect(account?.id, index)}
                                            disabled={linking[index]} // Disable button while loading
                                        >
                                            {linking[index] ? (
                                                <span>Please Wait...</span>
                                            ) : (
                                                <span>Connect Account</span>
                                            )}
                                        </button>
                                    </td>
                                </tr>
                            ))
                        )}
                    </tbody>
                </table>
            </div>
        </div>
    );
};
